<style lang="scss" scoped>
.error-msg {
    display: flex;
    margin-bottom: 8px;
    .error-icn {
        width: 20px;
        height: 20px;
        background: var(--danger);
        color: #fff;
        display: block;
        border-radius: 3px;
        text-align: center;
        line-height: 20px;
        flex: none;
        margin-right: 15px;
    }
    .error-txt {
        color: var(--danger);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>

<template>
    <div v-if="error">
        <transition-group name="fade">
            <div v-for="e in compiledErrors" :key="`${e.message}_error`" class="flex-none error-msg d-flex small">
                <span class="my-auto error-icn">!</span>
                <div class="my-auto error-txt">{{ $t(`errors.${e.message}`, [e.field, ...e.params]) }}</div>
            </div>
        </transition-group>
    </div>
</template>

<script>
export default {
    name: "Forms.Elements.ElError",

    props: {
        error: {
            default: false
        }
    },

    computed: {
        compiledErrors() {
            if (!this.error) return [];

            if (typeof error_tmp === "string") return [this.error];

            return this.error.errors;
        }
    }
};
</script>
